import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ParkingBaySection } from 'src/app/core/models/parking-bay-section';
import { ParkingBaySectionService } from 'src/app/core/services/general/parking-bay-section.service';

@Component({
  selector: 'app-parking-bay-section-input',
  templateUrl: './parking-bay-section-input.component.html',
  styleUrls: ['./parking-bay-section-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ParkingBaySectionInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ParkingBaySectionInputComponent,
    },
  ],
})
export class ParkingBaySectionInputComponent {
  @Input()
  title = "Select Parking Bay Section...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public parkingBaySectionsList: Array<CustomSelectOption> = [];

  constructor(
    private parkingBaySectionService: ParkingBaySectionService,
  ) {
    this.parkingBaySectionService
      .all()
      .subscribe((res: Array<ParkingBaySection>) => {
        this.parkingBaySectionsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.parkingBaySectionsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
